import { useState } from 'react';

export const LOADING_STATE = 'loading';

const locationFetch = duration =>
  new Promise(resolve => {
    setTimeout(resolve, duration);
  });
 
const getCurrentPosition = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
 
export default () => {
  const [geolocationData, setGeolocationData] = useState();
 
  const getGeolocationData = async () => {
    setGeolocationData({
      status: LOADING_STATE,
    });
 
    await locationFetch(500);
 
    try {
      const position = await getCurrentPosition();
      const {
        coords: { latitude, longitude },
      } = position;
 
      const successData = {
        coordinates: { latitude, longitude },
        status: 'success',
        statusMessage: 'Current location saved successfully.',
      };
 
      setGeolocationData(successData);
      return successData;
    } catch (error) {
      const errorData = {
        status: error.code === error.PERMISSION_DENIED ? 'denied' : 'error',
        statusMessage:
          error.code === error.PERMISSION_DENIED
            ? 'We can’t locate you. Please enable location access in your browser'
            : 'Unable to retrieve your current location.',
      };
 
      setGeolocationData(errorData);
      return errorData;
    }
  };

  return {
    geolocationData,
    getGeolocationData,
    setGeolocationData,
  };
};
